import axios from 'axios';

const instance = axios.create();
instance.defaults.baseURL = `${
  process.env.REACT_APP_API_SERVER || 'http://localhost:8080'
}/v1/`;

const setToken = () => {
  const token = localStorage.getItem('token');
  if (token) {
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
};

instance.interceptors.request.use(
  (config) => {
    setToken();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const api = {
  get: instance.get,
  post: instance.post,
  put: instance.put,
  delete: instance.delete,
  patch: instance.patch,
};

export default api;
